var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_317_1992)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.1241 14C27.1241 21.4562 21.0797 27.5006 13.6236 27.5006C6.16744 27.5006 0.123047 21.4562 0.123047 14C0.123047 6.5439 6.16744 0.499512 13.6236 0.499512C21.0797 0.499512 27.1241 6.5439 27.1241 14ZM14.1074 10.4662C12.7942 11.0124 10.1698 12.1428 6.23416 13.8575C5.59507 14.1117 5.26029 14.3603 5.22981 14.6034C5.1783 15.0143 5.69281 15.176 6.39344 15.3964C6.48875 15.4263 6.5875 15.4574 6.68873 15.4903C7.37805 15.7143 8.30529 15.9765 8.78733 15.9869C9.22459 15.9963 9.71261 15.8161 10.2514 15.4461C13.9286 12.9639 15.8268 11.7092 15.946 11.6822C16.0301 11.6631 16.1466 11.6391 16.2255 11.7093C16.3045 11.7794 16.2967 11.9123 16.2884 11.948C16.2374 12.1652 14.2177 14.0429 13.1726 15.0146C12.8467 15.3175 12.6156 15.5324 12.5684 15.5814C12.4625 15.6914 12.3547 15.7953 12.251 15.8953C11.6106 16.5126 11.1304 16.9756 12.2776 17.7316C12.8289 18.0949 13.27 18.3953 13.7102 18.695C14.1908 19.0223 14.6702 19.3488 15.2905 19.7554C15.4485 19.859 15.5994 19.9666 15.7464 20.0714C16.3058 20.4701 16.8083 20.8284 17.4291 20.7713C17.7899 20.7381 18.1625 20.3988 18.3518 19.3871C18.799 16.9962 19.6781 11.8157 19.8813 9.68096C19.8991 9.49393 19.8767 9.25457 19.8587 9.14949C19.8408 9.04442 19.8032 8.89471 19.6666 8.78388C19.5048 8.65263 19.2551 8.62495 19.1434 8.62692C18.6357 8.63587 17.8566 8.90676 14.1074 10.4662Z",
    fill: "#131316"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_317_1992"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.0011,
    height: 27.0011,
    fill: "white",
    transform: "translate(0.123047 0.499512)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon2);
export default __webpack_public_path__ + "static/media/icon-2.f062d2626eb4f3802ae1fcdd79ee4ff7.svg";
export { ForwardRef as ReactComponent };